// @flow
import React from 'react';
import H4 from '../H4';
import Img from "../Img";

import StyledZammadButton from './StyledZammadButton';

import imgTechSupport from '../../assets/img/technical-support.svg';

const $ = window.$;

export class ZammadButton extends React.Component {
  componentDidMount() {
    this.$el = $(this.el);
    this.$el.ZammadForm({
      messageTitle: 'Technical Support',
      messageSubmit: 'Submit',
      messageThankYou:
        "Thank you for your inquiry (#%s)! We'll contact you as soon as possible.",
      showTitle: true,
      modal: true,
    });
  }

  render() {
    return (
      <StyledZammadButton className="column">
        <a
          ref={el => (this.el = el)}
          className="zammad-button"
          id="technical-support-form"
        >
          <Img src={imgTechSupport} />
          <div className="contact-text">
            <H4>I need technical support</H4>
            <p>Get in touch with one of our technical experts to ask a question or report a bug</p>
          </div>
        </a>
      </StyledZammadButton>
    );
  }
}

export default ZammadButton;
